import React, { useState } from "react";
import { Tabs, Tab } from "react-bootstrap";
import styled from "styled-components";

import { CreateCredentialTab } from "./CreateCredentialTab";
import { LinkSchoolsTab } from "./LinkSchoolsTab";
import { ManualSyncTab } from "./ManualSyncTab";
import { ViewEntitiesTab } from "./ViewEntitiesTab";

const ConsoleLayout = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

const ConsoleCard = styled.div`
  background-color: white;
  border-radius: 12px;
  box-shadow: 0px 1px 2px 0px rgba(14, 26, 49, 0.05);
  padding: 32px;
`;

/**
 * The superuser Ednition Admin tool, cloned in structure from
 * SessionSummaryPromptConsole (react-bootstrap Tabs/Tab). Four tabs:
 * Create Credential / Link Schools / Manual Sync / View Entities. Every backend
 * call goes through request() from useOkoApi (Firebase bearer auto-attached).
 * Access is enforced by the superuser-guarded endpoints, not by a menu boolean.
 *
 * "Link Schools" is Feature #16's Step-1 human gate: for a client-keyed EDNITION
 * credential (SIS feed spanning multiple schools), the superuser maps each
 * Ednition school org to an existing OKO School before running the sync.
 */
export const EdnitionAdminConsole = () => {
  const [activeTab, setActiveTab] = useState("createCredential");

  return (
    <ConsoleLayout className="ednition-admin-console">
      <ConsoleCard>
        <Tabs
          activeKey={activeTab}
          onSelect={(k) => setActiveTab(k)}
          className="mb-3"
        >
          <Tab eventKey="createCredential" title="Create Credential">
            <CreateCredentialTab />
          </Tab>
          <Tab eventKey="linkSchools" title="Link Schools">
            <LinkSchoolsTab />
          </Tab>
          <Tab eventKey="manualSync" title="Manual Sync">
            <ManualSyncTab />
          </Tab>
          <Tab eventKey="viewEntities" title="View Entities">
            <ViewEntitiesTab />
          </Tab>
        </Tabs>
      </ConsoleCard>
    </ConsoleLayout>
  );
};
